import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { LicenseInfo } from '@mui/x-license';
import 'core-js';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration'
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client';
import ErrorBoundary from './Components/ErrorBoundary';
import { FirebaseAuthWrapper } from './Components/FirebaseAuthWrapper';
import reportWebVitals from './reportWebVitals';
import ClientProvider from './Providers/ClientProvider';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { SeasonShowProvider } from './Providers/SeasonShowProvider';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { SnackbarProvider } from './Providers/SnackbarProvider';
import AuthWrappedRoutes from './Routes';
import config from './config';
import { store } from './store';
import { StytchB2BProvider } from '@stytch/react/b2b';
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';
import theme from './theme';

declare global {
    interface Window {
        stytchClient: StytchB2BUIClient
    }
}

// eslint-disable-next-line import/no-named-as-default-member
dayjs.extend(duration);

// MUI-x Premium License Key
// eslint-disable-next-line max-len
LicenseInfo.setLicenseKey('ec0300d21d2628892849e514bc936598Tz0xMTkzMTQsRT0xNzg5ODYyMzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

const stytch = new StytchB2BUIClient(config.authPublicToken);
window.stytchClient = stytch;

const root = createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <StytchB2BProvider stytch={stytch}>
            <PostHogProvider
                apiKey={config.posthogPublicKey}
                options={{ api_host: config.posthogHost }}
            >
                <FirebaseAuthWrapper>
                    <ErrorBoundary>
                        <ClientProvider>
                            <Provider store={store}>
                                <SeasonShowProvider>
                                    <ThemeProvider theme={theme}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <CssBaseline />
                                            <SnackbarProvider>
                                                <DndProvider backend={HTML5Backend}>
                                                    <AuthWrappedRoutes />
                                                </DndProvider>
                                            </SnackbarProvider>
                                        </LocalizationProvider>
                                    </ThemeProvider>
                                </SeasonShowProvider>
                            </Provider>
                        </ClientProvider>
                    </ErrorBoundary>
                </FirebaseAuthWrapper>
            </PostHogProvider>
        </StytchB2BProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
reportWebVitals(console.log);